import React, { useState } from "react";

import { Grid } from "@mui/material";
import { FormButton, SpinnerOverlay } from "components";
import { FormikTextInput } from "components/UI/Inputs/FormikInputs";

import { Form, Formik } from "formik";
import * as yup from "yup";

import { useRecoilValue, useSetRecoilState } from "recoil";
import { snackbarData, userCredentials } from "recoilState/GlobalState";

import { FORM_ERROR_MESSAGES } from "consts/errorMessages";
import { mensajeLargo } from "consts/limites-campos";

import styles from "styles/pages/ModalActions.module.scss";
import { RNHHorarioUpd } from "services/services-mia/programa-salud/personal/RNHHorarioUpd";
import { codRegex, LARGO_HORARIO } from "../consts";

/**
 * Modificación de un horario. Mismo juego de campos y mismo orden que el alta, para
 * que quien los cargó los vuelva a encontrar donde estaban.
 *
 * La VERSION viaja con `??` en el servicio: la de un registro recién creado es 0 y un
 * `||` la mandaría null, que el back rechaza sin decir por qué.
 */
export default function UpdateModal({ updateList, horario, closeModal }) {
    const setSnackbarInfo = useSetRecoilState(snackbarData);
    const credentials = useRecoilValue(userCredentials);
    const [inRequest, setInRequest] = useState(false);

    const handleSubmit = async (values) => {
        setInRequest(true);
        const respuesta = await RNHHorarioUpd(credentials, {
            id: horario?.id,
            version: horario?.version,
            cod: values.cod,
            nombre: values.nombre,
            descripcion: values.descripcion,
        });
        setInRequest(false);

        if (!respuesta.ok) return;

        setSnackbarInfo({
            message: "Horario modificado correctamente",
            severity: "success",
            open: true,
        });
        updateList();
        closeModal();
    };

    return (
        <Formik
            initialValues={{
                cod: horario?.cod ?? "",
                nombre: horario?.nombre ?? "",
                descripcion: horario?.descripcion ?? "",
            }}
            validationSchema={yup.object({
                cod: yup
                    .string()
                    .max(LARGO_HORARIO.cod, mensajeLargo(LARGO_HORARIO.cod))
                    .matches(codRegex, "Debe tener solo letras y/o números")
                    .required(FORM_ERROR_MESSAGES.required),
                // Nombre y descripcion son TEXTO LIBRE: solo largo y requerido, como el
                // resto de los ABM del modulo. No se valida el juego de caracteres.
                nombre: yup
                    .string()
                    .max(LARGO_HORARIO.nombre, mensajeLargo(LARGO_HORARIO.nombre))
                    .required(FORM_ERROR_MESSAGES.required),
                descripcion: yup
                    .string()
                    .max(LARGO_HORARIO.descripcion, mensajeLargo(LARGO_HORARIO.descripcion))
                    .required(FORM_ERROR_MESSAGES.required),
            })}
            onSubmit={handleSubmit}
        >
            <Form className={styles.inputs} noValidate>
                <div className={styles["column"]}>
                    <Grid
                        container
                        rowSpacing={0}
                        columnSpacing={2}
                        sx={{
                            width: "100%",
                            "& .MuiFormControl-root": { marginTop: 0, marginBottom: 0 },
                        }}
                    >
                        <Grid item xs={4}>
                            <FormikTextInput
                                fullWidth
                                name="cod"
                                labelText="Código"
                                inputProps={{ maxLength: LARGO_HORARIO.cod }}
                                onKeyDown={(e) => {
                                    if (e.key === " ") e.preventDefault();
                                }}
                            />
                        </Grid>
                        <Grid item xs={8}>
                            <FormikTextInput
                                fullWidth
                                name="nombre"
                                labelText="Nombre"
                                inputProps={{ maxLength: LARGO_HORARIO.nombre }}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <FormikTextInput
                                fullWidth
                                name="descripcion"
                                labelText="Descripción"
                                inputProps={{ maxLength: LARGO_HORARIO.descripcion }}
                            />
                        </Grid>
                    </Grid>
                    <FormButton
                        inRequest={inRequest}
                        newFormData={{ button: "Guardar cambios" }}
                        onCloseModal={closeModal}
                    />
                    {inRequest && <SpinnerOverlay />}
                </div>
            </Form>
        </Formik>
    );
}
